import input from './binders/input.js';
import textarea from './binders/textarea.js';
import select from './binders/select.js';
import progress from './binders/progress.js';
import output from './binders/output.js';
// defaultBinders collection by default contains only one function-checker
var defaultBinders = [function (node) {
  switch (node.tagName) {
    case 'INPUT':
      return input(node.type);
    case 'TEXTAREA':
      return textarea();
    case 'SELECT':
      return select(node.multiple);
    case 'PROGRESS':
      return progress();
    case 'OUTPUT':
      return output();
    default:
      return null;
  }
}];
export default defaultBinders;